import React, { useMemo, useState, useEffect } from "react"

import {
  BaseTable,
  MarginBalanceTable,
  tableInformation,
  TrustBalanceTable,
  TrustBalanceTableSP,
} from "components/molecules/table"
import { trustTableColumns } from "config/table_columns"
import { Pagination } from "components/molecules/pagination"
import { PAGE_NUM } from "config/const"
import { slice, pick, isEmpty, get } from "lodash"
import APIs from "redux/apis"
import { Tab } from "components/atoms/btn/tab"
import { checkIsSp, judgingKakuhoFlag } from "utils/util"
import { Modal } from "react-bootstrap"
import * as Formatter from "utils/Formatter"
import ClassNames from "classnames"
import { pageLoadRegist } from "redux/ducks/PageLoad"
import { useDispatch } from "react-redux"
import uuid from "uuid"

interface props {
  data?: Array<object>
}

export const MarginBalance: React.FC<props> = props => {
  const tableColumnList = [trustTableColumns.base, trustTableColumns.summary]
  return (
    <>
      <div className="control-row filter-control-row balance">
        <div className="title-contents">
          <div className="title-border">日証金 差引残高株数合計情報</div>
          <div className="jsf-text">
            <span>JSF</span>
            <span>{judgingKakuhoFlag(get(props.data, "KakuhoFlag"))}</span>
          </div>
        </div>
      </div>
      <MarginBalanceTable
        tableColumns={tableColumnList}
        data={props.data}
        className="table-margin-balance balance"
      />
    </>
  )
}

export const TrustBalance: React.FC<props> = props => {
  const isSp = checkIsSp()
  return (
    <>
      <div className="control-row filter-control-row">
        <div className="title-border">二市場信用取引現在高</div>
        {isSp && <span className="emphasis">※ 単位: 1000株 100万円</span>}
      </div>
      {isSp ? (
        <TrustBalanceTableSP data={props.data} />
      ) : (
        <TrustBalanceTable data={props.data} />
      )}
    </>
  )
}

type StockLoanInfoProps = {
  tableType?: Array<tableInformation>
  data?: Array<object>
  setExchange?: Function
  exchange?: number
  contentFlag?: boolean
  changeContentFlag?: Function
}

export const StockLoanInfo: React.FC<StockLoanInfoProps> = props => {
  const _data = useMemo(() => {
    return props.data || []
  }, [props.data])
  const [isOpen, changeDisplay] = useState<boolean>(false)
  const [currentPage, setCurrentPage] = useState(0)
  const [dataSource, setDataSource] = useState([])
  const [selectedData, setSelectedData] = useState<any>({})
  const [detailSymbol, setDetailSymbol] = useState({})
  const [active, changeActive] = useState(0)
  const [exchangeFlag, changeExchangeFlag] = useState(false)
  const tableColumnList = [
    trustTableColumns.lendingOrLoanBase,
    trustTableColumns.lending,
    trustTableColumns.order,
  ]
  const isSp = useMemo(() => {
    return checkIsSp()
  }, [])
  const Page_Num = useMemo(() => {
    return !isSp ? PAGE_NUM.PAGE_10 : PAGE_NUM.PAGE_50
  }, [isSp])
  const loadResistId = useMemo(() => uuid(), [])
  const dispatch = useDispatch()

  const _setSelectedData = (data: object) => {
    const SymbolData = pick(data, "Symbol")
    setSelectedData({
      ...SymbolData,
      Exchange: props.exchange,
      SecurityType: 1,
    })
  }

  useEffect(() => {
    const _dataSource = slice(
      _data,
      currentPage * Page_Num,
      (currentPage + 1) * Page_Num
    )
    ;(async () => {
      dispatch(pageLoadRegist(loadResistId, true))
      if (!isEmpty(_dataSource) && !exchangeFlag && !props.contentFlag) {
        const data = await await APIs.SymbolDetail.SymbolDetail({
          ..._dataSource[0],
          Exchange: props.exchange,
          SecurityType: 1,
        })
        const resultList = get(data, "Symbol", {})
        const stockShort =
          get(resultList, "KashikabuZan") - get(resultList, "YuushiZan")
        const buy =
          get(resultList, "KashikabuShinki") + get(resultList, "YuushiHensai")
        const sell =
          get(resultList, "KashikabuHensai") + get(resultList, "YuushiShinki")
        setDetailSymbol({ ...resultList, stockShort, buy, sell })
      }
      await setDataSource(_dataSource)
      changeExchangeFlag(false)
      props.changeContentFlag(false)
      dispatch(pageLoadRegist(loadResistId, false))
    })()
  }, [currentPage])

  useEffect(() => {
    const _dataSource = slice(
      _data,
      currentPage * Page_Num,
      (currentPage + 1) * Page_Num
    )
    setDataSource(_dataSource)
    if (!isEmpty(_dataSource)) {
      _setSelectedData(_dataSource[0])
    }
  }, [_data])

  useEffect(() => {
    setCurrentPage(0)
    changeActive(0)
  }, [props.exchange])

  useEffect(() => {
    if (props.contentFlag) {
      setCurrentPage(0)
      changeActive(0)
    }
  }, [props.contentFlag])

  useEffect(() => {
    if (
      isEmpty(selectedData) ||
      !selectedData.Symbol ||
      !selectedData.Exchange ||
      !selectedData.SecurityType
    )
      return
    ;(async () => {
      dispatch(pageLoadRegist(loadResistId, true))
      const data = await await APIs.SymbolDetail.SymbolDetail({
        ...selectedData,
      })
      const resultList = get(data, "Symbol", {})
      const stockShort =
        get(resultList, "KashikabuZan") - get(resultList, "YuushiZan")
      const buy =
        get(resultList, "KashikabuShinki") + get(resultList, "YuushiHensai")
      const sell =
        get(resultList, "KashikabuHensai") + get(resultList, "YuushiShinki")
      setDetailSymbol({ ...resultList, stockShort, buy, sell })
      dispatch(pageLoadRegist(loadResistId, false))
    })()
  }, [selectedData])

  return (
    <div className="split-division">
      <div className="split-container">
        <div className="tab-wrapper">
          <Tab
            className="tab-panel"
            list={[
              { name: "日証金（東証）", id: 1 },
              { name: "日証金（名証）", id: 3 },
            ]}
            active={props.exchange}
            onChange={(id: number) => {
              props.setExchange(id)
              changeActive(0)
              changeExchangeFlag(true)
            }}
          />
          <BaseTable
            className="table-list-view table-liquid-cell"
            list={props.tableType}
            data={dataSource}
            onClick={async (data: object, index: number) => {
              changeActive(index)
              _setSelectedData(data)
              isSp && (await changeDisplay(true))
            }}
            active={active}
          />
          <Pagination
            list={_data}
            current={currentPage}
            page={Page_Num}
            changePage={(page: number) => {
              setCurrentPage(page)
              changeActive(0)
              if (isSp && get(window, "scrollTo")) window.scrollTo(0, 0)
            }}
          />
        </div>
      </div>
      {isSp ? (
        <Modal
          show={isOpen}
          onHide={() => changeDisplay(false)}
          size="lg"
          className="trust-modal"
        >
          <Modal.Header className="trust-modal-header">
            <span className="symbol-code">{get(detailSymbol, "Symbol")}</span>
            <span className="symbol-code-name">
              {get(detailSymbol, "SymbolNameS")}
            </span>
          </Modal.Header>
          <Modal.Body className="trust-modal-body">
            <div>
              <div className="jsf-text">
                <span>JSF</span>
                <span>
                  {judgingKakuhoFlag(get(detailSymbol, "KakuhoFlag"))}
                </span>
              </div>
              <table className="table table-margin-balance sp">
                <thead>
                  <tr>
                    <th />
                    <th>貸株</th>
                    <th>融資</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="title-col">新規</td>
                    <td>
                      {Formatter.number(get(detailSymbol, "KashikabuShinki"))}
                    </td>
                    <td>
                      {Formatter.number(get(detailSymbol, "YuushiShinki"))}
                    </td>
                  </tr>
                  <tr>
                    <td className="title-col">返済</td>
                    <td>
                      {Formatter.number(get(detailSymbol, "KashikabuHensai"))}
                    </td>
                    <td>
                      {Formatter.number(get(detailSymbol, "YuushiHensai"))}
                    </td>
                  </tr>
                  <tr>
                    <td className="title-col">残高</td>
                    <td>
                      {Formatter.number(get(detailSymbol, "KashikabuZan"))}
                    </td>
                    <td>{Formatter.number(get(detailSymbol, "YuushiZan"))}</td>
                  </tr>
                  <tr>
                    <td className="title-col">差引</td>
                    <td>
                      <div
                        className={ClassNames(
                          "change-price-value liquid-item",
                          Formatter.upDown(get(detailSymbol, "SashihikiZan"))
                        )}
                      >
                        {Formatter.number(get(detailSymbol, "SashihikiZan"))}
                      </div>
                    </td>
                    <td>
                      <div
                        className={ClassNames(
                          "change-price-value liquid-item",
                          Formatter.upDown(
                            get(detailSymbol, "SashihikiZanZenhi")
                          )
                        )}
                      >
                        {Formatter.number(
                          get(detailSymbol, "SashihikiZanZenhi")
                        )}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="title-col">回転日数</td>
                    <td>
                      {Formatter.number(get(detailSymbol, "KaitenNissuu"), 1)}
                    </td>
                    <td />
                  </tr>
                </tbody>
              </table>
              <table className="table table-margin-balance sp">
                <tbody>
                  <tr>
                    <td className="title-col">貸借値段</td>
                    <td>
                      {Formatter.number(get(detailSymbol, "TaishakuNedan"), 1)}
                    </td>
                  </tr>
                  <tr>
                    <td className="title-col">貸借比率</td>
                    <td>
                      {Formatter.number(
                        get(detailSymbol, "TaishakuBairitsu"),
                        2
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td className="title-col">品貸料</td>
                    <td>
                      {Formatter.number(get(detailSymbol, "GyakuHibu"), 2) ||
                        "-"}
                    </td>
                  </tr>
                  <tr>
                    <td className="title-col">株不足</td>
                    <td>{Formatter.number(get(detailSymbol, "stockShort"))}</td>
                  </tr>
                  <tr>
                    <td className="title-col">買申し込み</td>
                    <td>{Formatter.number(get(detailSymbol, "buy"))}</td>
                  </tr>
                  <tr>
                    <td className="title-col">売申し込み</td>
                    <td>{Formatter.number(get(detailSymbol, "sell"))}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="modal-bottom-btn-row">
              <div
                className="btn btn-outline ripple"
                onClick={() => changeDisplay(false)}
              >
                閉じる
              </div>
            </div>
          </Modal.Footer>
        </Modal>
      ) : (
        <div className="split-container">
          <div className="jsf-text">
            <span>JSF</span>
            <span>{judgingKakuhoFlag(get(detailSymbol, "KakuhoFlag"))}</span>
          </div>
          <MarginBalanceTable
            tableColumns={tableColumnList}
            className="table-margin-balance"
            data={detailSymbol}
          />
        </div>
      )}
    </div>
  )
}
